import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common'
import { Router,ActivatedRoute } from '@angular/router';
import { Chart } from 'chart.js';
import { Location } from '@angular/common';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ExcelService } from 'src/app/Services/ExcelService/excel.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import {

  CalendarMonthViewBeforeRenderEvent,
  CalendarWeekViewBeforeRenderEvent,
  CalendarDayViewBeforeRenderEvent,

} from 'angular-calendar';



import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
  startOfHour,
} from 'date-fns';

/**import { time } from 'console';*/

interface Appointment {
  fullName: string;
  timeIn: string;
  timeOut: string;
  pid:string;
  phoneNumber:string;
  branch:string;
  salesRep:string;
  salesRepID:string;
   
 }
@Component({
  selector: 'app-all-local-appointments',
  templateUrl: './all-local-appointments.component.html',
  styleUrls: ['./all-local-appointments.component.css']
})
export class AllLocalAppointmentsComponent implements OnInit {

  public daterange: any = {};

  searchForm: FormGroup;
  searchText;
  allAptSearchText;
  //_url= 'http://multiinspectionreport.com/reception/api';
  //_url= 'https://test.appointele.com/api';
  //_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
  
  allupcomingbranchappointment=[];
  allbranchappointment=[];
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ appointment: Appointment }>[]>;
  activeDayIsOpen: boolean = false;

  allappointment=[];
  searchResult=[];
  error=[];
  currentUser:User;
  username;
  branch;
role;

salesReplist;

color;
success;

loggedInUsername;
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;

calendarview=true;
tableview=false;

public options: any = {
  locale: { format: 'YYYY-MM-DD' },
  alwaysShowCalendars: false,
};


  constructor(private fb: FormBuilder,
      private router: Router,
      private _location: Location,
      private actroute: ActivatedRoute,
      private _authenticationService: AuthenticationService,
      private _appointment: AppointmentService,
      private _http: HttpClient,
      public datepipe: DatePipe,
      private excelService:ExcelService) {
        this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
        if(this.currentUser){
          
          this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
          this.branch=this.currentUser.branch;
          this.role=this.currentUser.role;


          this.loggedInUsername=this.currentUser.userName;
          this.loggedInUserFullname= this.username;
          this.loggedInUserBranch= this.branch
          this.loggedInUserId=this.currentUser.userName;
      
          
      
         }

       }
  ngOnInit(): void {
    this.getSalesRepList(this.branch);
    this.getAllUpcomingAppointmentForTableView();
    this.getAllAppointmentForTableView();
    this.fetchEvents();


  this.searchForm = this.fb.group({
    branch: new FormControl(this.loggedInUserBranch),
    startDate: new FormControl(''),
    endDate: new FormControl(''),
    salesRep: new FormControl(''),
     requestType: new FormControl(''),
     status: new FormControl(''),
     
   });

    var cal = document.getElementById("calendar");
    cal.style.display = "none";
  
    var upcomingappointment = document.getElementById("upcomingappointment");
    upcomingappointment.style.display = "block";

    var customsearch = document.getElementById("customsearch");
    customsearch.style.display = "none";

    document.getElementById ("calendarview").addEventListener ("click", CalendarFunction, false);
    document.getElementById ("upcomingappointmentview").addEventListener ("click", UpcomingappointmentFunction, false);
    document.getElementById ("customsearchview").addEventListener ("click", CustomSearchFunction, false);
  }//End of ngOnInit



exportAsXLSX():void {
  if(this.searchResult!=null || this.searchResult .length>=1){
  this.excelService.exportAsExcelFile(this.searchResult , 'Search_Report');
  }
}


  getSalesRepList(branch){
    //  console.log(branch);
      if (branch != "None" || branch!="") {
        this._appointment.getSalesRepByBranch(branch).subscribe(
          (res) => {
            this.salesReplist = res;
        // console.log(this.salesReplist);
            
         
          }
          ,
          (err) => {
            this.error = err;
          }
        );
      }
   
      }

      
  openAppointment(list){
  //.log(list.pid);
   
    this.router.navigate(['../appointment-details', { extra: list.pid, extra1: list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn }], { relativeTo: this.actroute });
  }

  getAllAppointmentForTableView(){
   // console.log(this.branch);
  
    this._appointment.getAllAppointmentForBranch(this.branch).subscribe(
      (res) => {
        this.allbranchappointment= res[0];
       //  console.log(this.allbranchappointment);
      },
      (err) => {
        this.error = err;
      }
    );
  
  }


  getAllUpcomingAppointmentForTableView(){
    // console.log(this.branch);
   
     this._appointment.getAllUpcomingAppointmentForBranch(this.branch).subscribe(
       (res) => {
         this.allupcomingbranchappointment= res[0];
         // console.log(this.allupcomingbranchappointment);
       },
       (err) => {
         this.error = err;
       }
     );
   
   }


  changeView(option){
    if(option=='calendar'){
this.calendarview==false;
this.tableview==true;
    }else if(option=='table'){

    }
  }

onSearchSubmit(){
  this._appointment.customAppointmentSearch(this.searchForm.value)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.searchResult=response;
      this.searchForm.reset;        
     // document.getElementById("openSuccessModalButton").click();
    },
      error => {console.error('Error!', error);
      this.error=error.error.text ;
    }       
    );

}


  backClicked() {
    this._location.back();
  }




  completeAppointment(list){
    this._appointment.setAppointmentStatusbypid(list)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.success=response['SUCCESS'];
          
      document.getElementById("openSuccessCompleteModalButton").click();
      
    },
      error => {console.error('Error!', error);
      this.error=error.error.text ;
    }       
    );
  }
  
  deleteAppointment(list){
    list['actionPerformedBy']=this.loggedInUsername;
    list['role']=this.role;
    this._appointment.deleteAppointmentbypid(list)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.success=response['SUCCESS'];
          this.onSearchSubmit();
      document.getElementById("openSuccessDeleteModalButton").click();
    },
      error => {console.error('Error!', error);
      this.error=error.error.text ;
    }       
    );
  }

editAppointment(list){
 //.log(list);
  if(list.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:list.pid,extra1:list.timeIn,extra2:list.salesRep,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
  }else{
 
 
   this.router.navigate(['../appointment-edit',{extra:list.pid,extra1:list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
  }
}



public selectedDate(value: any, datepicker?: any) {
  // this is the date  selected
  //console.log(value);

  // any object can be passed to the selected event and it will be passed back here
  datepicker.start = value.start;
  datepicker.end = value.end;

  // use passed valuable to update state
  this.daterange.start = value.start;
  this.daterange.end = value.end;
  this.daterange.label = value.label;
  //console.log(this.daterange.start['_d']);
  this.searchForm.patchValue({
    startDate: this.daterange.start['_d'],
    endDate:this.daterange.end['_d']
});
}

  /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
      hour: startOfHour,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];


    
  this.events$ = this._http.get(`${this._url}/active_all_appointment_for_branch_get.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Appointment[] }) => {
     // console.log(results);
      this.allappointment=results;
      //console.log(this.allappointment);
      return results.map((appointment: Appointment) => {
     /**   if(appointment.salesRep=='Nicolas Salazar'){
          this.color=colors.blue;
        }else if(appointment.salesRep=='Tom Kizito'){
          this.color=colors.yellow;
        }**/
        this.colorForRep(appointment.salesRep);

        if(appointment.timeOut!="" && appointment.timeOut!=null){
         // var timeOut=this.datepipe.transform(new Date(appointment.timeOut), 'yyyy-MM-dd h:mm a');
         var timeOut=appointment.timeOut;
        } else {
       //   console.log(appointment.fullName);
          if(appointment.timeIn!=null && appointment.timeIn!=""){
          var timeOute=new Date(appointment.timeIn);
          var time=new Date(timeOute.setMinutes(timeOute.getMinutes() + 30));
          timeOut=this.datepipe.transform(time, 'yyyy-MM-dd h:mm a',"z-0600");
        //  console.log(res[i].timeIn);
          }
        }
        
        return {
         
          title: appointment.fullName+' - '+(new Date(appointment.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' ')+' - '+appointment.salesRep,
          start: new Date(
            appointment.timeIn
          ),
          
          
          color:this.color,
          
          meta: {
            appointment,
          },
        };
      });
    })
  );


}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ appointment: Appointment }>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}



eventClicked(event: CalendarEvent<{ appointment: Appointment }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/
  if(event.meta.appointment.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:event.meta.appointment.pid,extra1:event.meta.appointment.timeIn,extra2:event.meta.appointment.salesRepID,extra3:event.meta.appointment.branch,extra4:event.meta.appointment.timeIn}],{relativeTo:this.actroute});
  }else{
  this.router.navigate(['../appointment-details', { extra:event.meta.appointment.pid, extra1: event.meta.appointment.fullName,extra2:event.meta.appointment.phoneNumber,extra3:event.meta.appointment.branch,extra4:event.meta.appointment.timeIn }], { relativeTo: this.actroute });
}
}



colorForRep(salesRep){

  
  if(this.salesReplist.some(array=> array.fullName===salesRep)){
    const i= this.salesReplist.findIndex(array=> array.fullName===salesRep);
    //console.log(salesRep);
    
   // console.log(this.salesReplist[i].color)
    if(this.salesReplist[i].color!=null && this.salesReplist[i].color!=""){
      var colour=new String(this.salesReplist[i].color);
      //console.log(this.salesReplist[i].color);
    this.color={primary:this.salesReplist[i].color,secondary:this.salesReplist[i].color};
    } else if(salesRep==''){
      this.color=colors.red;
    } else {
      this.color=colors.black;
    }
    }

  else if(salesRep==''){
    this.color=colors.red;
  } else {
    this.color=colors.black;
  }

}


/***************************************** */
refreshPage() {
  window.location.reload();
}
/***************************************** */
isAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

isSystemAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}

isReceptionist() {
  return this.currentUser && this.currentUser.role === UserRole.Receptionist;
}

isSalesRep() {
  return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
}

isPowerUser() {
  return this.currentUser && this.currentUser.role === UserRole.PowerUser;
}

isSalesSupport() {
  return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
}

}

function CalendarFunction() {
  var cal = document.getElementById("calendar");
  cal.style.display = "block";

  var upcomingappointment = document.getElementById("upcomingappointment");
  upcomingappointment.style.display = "none";

  var customsearch = document.getElementById("customsearch");
  customsearch.style.display = "none";

  
}


function UpcomingappointmentFunction() {
  var upcomingappointment = document.getElementById("upcomingappointment");
  upcomingappointment.style.display = "block";
  var cal = document.getElementById("calendar");
  cal.style.display = "none";
  var customsearch = document.getElementById("customsearch");
  customsearch.style.display = "none";
}




function CustomSearchFunction() {
  var customsearch = document.getElementById("customsearch");
  customsearch.style.display = "block";
  var cal = document.getElementById("calendar");
  cal.style.display = "none";
  var upcomingappointment = document.getElementById("upcomingappointment");
  upcomingappointment.style.display = "none";
 

}
 


  
